import React from 'react'
import './styles.css'

const Spinner = () => <div className="loader"></div>;

export default Spinner;